import { action, makeObservable, observable } from "mobx";
import PlacesApi, { PlacesApi as IPlacesApi } from "../../../../../../services/api/v2/places/Places.api";

export class ProjectMapReportingModel {
  isLoading: boolean = true;
  placesApi: IPlacesApi;
  organisationId: number;
  projectId: number;
  placeId: number;
  getUrl: (organisationId: number, projectId: number, itemIds?: string[]) => string;
  @observable placeImpactProjectPieChartData: any = [];
  /**
   *
   */
  constructor(organisationId: number, projectId: number, placeId: number) {
    makeObservable(this);
    this.organisationId = organisationId;
    this.projectId = projectId;
    this.placesApi = PlacesApi;
    this.placeId = placeId;
  }

  @action
  onMount = async () => {
    await this.loadPlaces();
  };

  @action
  onUnmount = () => {};

  @action
  loadPlaces = async () => {
    try {
      this.setIsLoading(true);
      const res = await this.placesApi.getPlaceImpactProjectCount(this.organisationId, this.placeId, this.projectId);
      this.mapDataForPieChart(res.payload);
    } catch (error) {
      console.error(error);
      this.setIsLoading(false);
    } finally {
      this.setIsLoading(false);
    }
  };

  mapDataForPieChart = data => {
    let pieChartData = [];
    data.forEach(project => {
      if (project.projectId === 0 && project.projectName == null) {
        return;
      }
      pieChartData.push({
        color: "",
        id: project.projectId,
        label: project.projectName,
        value: project.impactCount
      });
    });
    this.setPlaceImpactProjectPieChartData(pieChartData);
  };

  @action
  setPlaceImpactProjectPieChartData = data => {
    this.placeImpactProjectPieChartData = data;
  };

  @action
  setIsLoading = (isLoading: boolean) => {
    this.isLoading = isLoading;
  };
}
